import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class AvatarComponent extends Component {
    static propTypes = {
        hasImage: PropTypes.bool,
        messageId: PropTypes.string,
        avatarUrl: PropTypes.string.isRequired,
        hiddenAvatars: PropTypes.object.isRequired,
    };

    _getAvatarClasses(hideAvatarForCarousel) {
        const { hasImage } = this.props;
        const avatarClasses = hasImage ? ['msg-avatar', 'msg-avatar-img'] : ['msg-avatar'];

        if (hideAvatarForCarousel) {
            avatarClasses.push('msg-avatar-hidden');
        }

        return avatarClasses.join(' ');
    }

    render() {
        const { avatarUrl, messageId, hiddenAvatars } = this.props;
        const hideAvatarForCarousel = hiddenAvatars[messageId];

        return (
            <div className={this._getAvatarClasses(hideAvatarForCarousel)}>
                <img alt={`${name}'s avatar`} src={avatarUrl} />
            </div>
        );
    }
}

export default connect(({ avatar: { hiddenAvatars } }) => {
    return {
        hiddenAvatars,
    };
})(AvatarComponent);
